import React, { Component } from 'react';
import NavBlockMiami from './NavBlockMiami';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import {dp, createFolderTree} from '../../../utils/shared.js';
import _ from 'lodash';

class NavMiami extends Component {
  constructor(props) {
    super(props);
    
    this._background = null;
    this._arrow = null;
    this._logo = null;

    this.state = {
      initializedRefs: false,
      navTree: null
    }
    this.navRefs = [];
  }

  handleNav = (route) => {
    this.props.navRoute(route.navLocation, route.module);
  }
  
  componentDidMount() {
    this.initializeAssets();
    this.props.toggleShowNav(false);
  }

  componentWillUnmount() {
    for (let a = 0; a < this.navRefs.length; a++) {
      if (this.navRefs[a].el) {
        this.navRefs[a].el.removeEventListener("tap", () => this.handleNav(this.navRefs[a].data));
      }
    }
    this.props.toggleShowNav(true);
  }

  initializeNavRefs = () => {
    if (this.state.initializedRefs === false) {
      for (let a = 0; a < this.navRefs.length; a++) {
        this.navRefs[a].el.addEventListener("tap", () => this.handleNav(this.navRefs[a].data));
      }
      this.setState({
        initializedRefs: true
      })
    }
  }

  initializeAssets = () => {
    let rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    if (rootFolderId !== null && rootFolderId !== undefined) {
      rootFolderId = Number(rootFolderId);
    }
    const rootFolder = this.props.content.story_categories.find(folder => folder.id === rootFolderId);
    const menu = this.props.content.story_categories.find(folder => {
      const folderType = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === rootFolderId && folderType === "menu";
    });
    
    if (menu) {
      const navTree = createFolderTree(this.props.content.story_categories, this.props.content.folder_modules, null, this.props.content.stories, this.props.content.dm_active, menu.id, 'sorting_name');
      this.setState({
        navTree: navTree
      });
    }

    this._arrow = dp(this.props.screen, _.get(menu, 'contents.images[0]', null));
    this._logo = dp(this.props.screen, _.get(rootFolder, 'contents.images[0]', null));
    this._background = dp(this.props.screen, _.get(rootFolder, 'contents.images[1]', null));
  }

  prepareMenuNavigation() {
    if (!this.state.navTree) {
      return null;
    }
    let location = [];
    return (
      this.state.navTree.children.map((row, i) => {
        const type = _.get(row, 'contents.custom_fields.folder_type.val.value', null);
        row.modalEnabled = false;
        switch (type) {
          case "message_cfo":
            location[i] = "/miami/message";
            break;
          case "donor_stories_text_block_picture":
            location[i] = "/miami/storiespictures";
            row.modalEnabled = true;
            break;
          case "donor_stories_text_block":
            location[i] = "/miami/stories";
            break;
          case "donor_stories_pill":
            location[i] = "/miami/storypills";
            row.modalEnabled = true;
            row.isGrouped = false;
            break;
          case "videos":
            location[i] = "/miami/storypills";
            row.modalEnabled = true;
            row.isGrouped = false;
            break;
          case "timeline":
            location[i] = "/miami/timeline";
            break;
          case "be_the_change":
            location[i] = "/miami/subscribe";
            break;
          case "search":
            location[i] = "/miami/subscribe";
            break;
          case "donor_lists_wrapper":
            location[i] = "/miami/recognitionlist";
            break;
          default:
            break;
        }
        
        return (
          <div key={i}>
            <div ref={el => this.navRefs[i] = { el: el, data: { navLocation: location[i], module: row } }}>
              <NavBlockMiami
                handleNav={this.handleNav}
                title={row.name}
                description={row.description}
                screen={this.props.screen}
                containerWidth={this.props.screen.screenWidth / this.props.screensNumber}
                icon={dp(this.props.screen, _.get(row, 'contents.images[0]', null))}
                arrow={this._arrow}/>
            </div>
            <div style={{ height: '0.7vh' }}></div>
          </div>
        )
      })
    )
  }

  render() {
    const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
    return (
      <div style={{ height: this.props.screen.r9_16.height, textAlign: 'center', width: '100%', backgroundSize: backgroundSize, backgroundImage: "url("+this._background+")" }}>
        <div style={{ height: '5vh' }}></div>
        <div style={{ width:this.props.screen.screenWidth / this.props.screensNumber }}>
          <img alt="Logo" src={this._logo} style={{ display: 'block', margin: 'auto', width: '39vh' }} />
          <div style={{ height: '4vh' }}></div>
          <div style={{ width: this.props.screen.screenWidth, height: '100vh', touchAction:"none" }}>
            <ReactIScroll ref={el => this.iScroller = el} iScroll={iScroll}
              options={{
                mouseWheel: true,
                scrollbars: false,
                scrollX: false,
                scrollY: true,
                probeType: 2,
                bounce: false,
                momentum: true,
                deceleration: 0.005,
                useTransition: true,
                disableTouch: false,
                disablePointer: false,
                disableMouse: false,
                tap: true
              }}
              onScrollStart={this.onScrollStart}
              onRefresh={this.initializeNavRefs}
            >
              <div style={{ width: this.props.screen.screenWidth / this.props.screensNumber }}>
                {this.prepareMenuNavigation()}
              </div>
            </ReactIScroll>
          </div>
        </div>
      </div>
    )
  }
}

export default NavMiami


// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/NavMiami.js